<template>
  <div style="height: 100%">
    <div style="width: 100%; display: flex; height: 100%">
      <div class="left">
        <img
          src="../assets/images/head.png"
          style="width: 32px; height: 32px; margin-top: 10px"
        />
        <div class="tag">
          <div class="arrow"><em></em><span></span></div>
          <div
            style="color: #b4b8bb;
              font-size: 13px;
              margin-top: 15px;
              margin-left: 10px;
              margin-right: 10px;
              line-height: 22px;
              height: 80px;
              text-align: left;">
            Hi {{ this.username }}, <br />
            <div style="margin-bottom: 10px"></div>
            Here comes
            <label style="font-weight: 700">{{ this.total }}</label>
            projects need your approval.
          </div>
          <el-form>
            <el-form-item>
              <el-button
                style="
                  margin-left: 10px;
                  margin-right: 10px;
                  margin-top: 25px;
                  width: 130px;
                  height: 40px;
                  text-align: center;
                  background: #a0d800;
                  border: 0px #a0d800;
                  color: black;
                "
                @click="startapproval"
                >Start Approval</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div class="iconList">
          <el-menu
            :default-active="defaultActive"
            class="el-menu-list"
            @open="handleOpen"
            @close="handleClose"
            background-color="#232b33"
            text-color="#fff"
            active-text-color="#ffd04b"
            style="border: none; text-align: left"
          >
            <el-submenu index="3" v-if="isadmin">
              <template slot="title">
                <span>Smart Approval</span>
              </template>
              <div style="height: 1px; background-color: #545c64"></div>
              <el-menu-item-group>
                <el-menu-item index="3-1" @click="endapproval">
                  <!-- <i class="el-icon-document"></i> -->
                  <span slot="title">- Handled Cases</span>
                </el-menu-item>
                <div style="height: 1px; background-color: #545c64"></div>
                <el-menu-item index="3-2" @click="Playbook">
                  <!-- <el-icon class="el-icon-reading"></el-icon> -->
                  <span slot="title">- Playbook</span>
                </el-menu-item>
                <div style="height: 1px; background-color: #545c64"></div>
              </el-menu-item-group>
            </el-submenu>
          </el-menu>
        </div>
      </div>
      <div class="right">
        <div class="top">
          <img
            src="../assets/images/adidas.png"
            style="width: 160px; height: 37px; margin-top: 10px"
          />
          <div style="margin-right: 10px; float: right">
            <img
              @click="logOut"
              style="margin: 20px 10px; cursor: pointer"
              title="Logout"
              src="../assets/icon/logout.png"
              v-if="false"
            />
            <img
              @click="help"
              style="margin: 20px 10px; cursor: pointer"
              title="Help"
              src="../assets/icon/help.png"
            />
            <!-- <el-button @click="logOut" type="info" icon="el-icon-question"
              >Logout</el-button
            >
            <el-button @click="help" type="info" icon="el-icon-question"
              >Help</el-button
            > -->
          </div>
        </div>
        <div class="content_title" style="display: none">
          <br />
          <el-table
            class="table_list"
            highlight-current-row
            :data="tableData"
            stripe
            style="width: 99%"
            @row-click="rowClick"
            :row-key="getRowKeys"
            :expand-row-keys="expands"
            @expand-change="expandChange"
            ref="tableList"
            v-loading="loading"
            element-loading-text="loading"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0)"
          >
            <el-table-column type="expand">
              <template>
                <el-table
                  highlight-current-row
                  :data="tableData2.datas"
                  style="width: 99%"
                >
                  <el-table-column
                    :label="tableData2.name1"
                    v-if="tableData2.isColumn1"
                    style="font-weight: bold"
                  >
                    <template slot-scope="scope">
                      <span :class="scope.row.class1">{{
                        scope.row.column1
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="tableData2.name2"
                    v-if="tableData2.isColumn2"
                  >
                    <template slot-scope="scope">
                      <span :class="scope.row.class2">{{
                        scope.row.column2
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="tableData2.name3"
                    v-if="tableData2.isColumn3"
                  >
                    <template slot-scope="scope">
                      <span :class="scope.row.class3">{{
                        scope.row.column3
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="tableData2.name4"
                    v-if="tableData2.isColumn4"
                  >
                    <template slot-scope="scope">
                      <span :class="scope.row.class4">{{
                        scope.row.column4
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="tableData2.name5"
                    v-if="tableData2.isColumn5"
                  >
                    <template slot-scope="scope">
                      <span :class="scope.row.class5">{{
                        scope.row.column5
                      }}</span>
                    </template></el-table-column
                  >
                  <el-table-column
                    :label="tableData2.name6"
                    v-if="tableData2.isColumn6"
                  >
                    <template slot-scope="scope">
                      <span :class="scope.row.class6">{{
                        scope.row.column6
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="tableData2.name7"
                    v-if="tableData2.isColumn7"
                  >
                    <template slot-scope="scope">
                      <span :class="scope.row.class7">{{
                        scope.row.column7
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="tableData2.name8"
                    v-if="tableData2.isColumn8"
                  >
                    <template slot-scope="scope">
                      <span :class="scope.row.class8">{{
                        scope.row.column8
                      }}</span>
                    </template></el-table-column
                  >
                  <el-table-column
                    :label="tableData2.name9"
                    v-if="tableData2.isColumn9"
                  >
                    <template slot-scope="scope">
                      <span :class="scope.row.class9">{{
                        scope.row.column9
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="tableData2.name10"
                    v-if="tableData2.isColumn10"
                  >
                    <template slot-scope="scope">
                      <span :class="scope.row.class10">{{
                        scope.row.column10
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="tableData2.name11"
                    v-if="tableData2.isColumn11"
                  >
                    <template slot-scope="scope">
                      <span :class="scope.row.class11">{{
                        scope.row.column11
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="tableData2.name12"
                    v-if="tableData2.isColumn12"
                  >
                    <template slot-scope="scope">
                      <span :class="scope.row.class12">{{
                        scope.row.column12
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="tableData2.name13"
                    v-if="tableData2.isColumn13"
                  >
                    <template slot-scope="scope">
                      <span :class="scope.row.class13">{{
                        scope.row.column13
                      }}</span>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-table-column>
            <el-table-column prop="Report" label="Public"></el-table-column>
          </el-table>
        </div>
        <div class="content_title-sub">
            <div class="sub-title">What's NEW</div>
            <div class="version">Version 1.0</div>
            <div class="sub-introduce-con">
              • We have launched mobile Smart Approvol in <span>Comp Portal</span> ! After simple steps below you can handle your approval 
              <span>EVERYWHERE</span> !
            </div>
            <div class="sub-img-lists">
              <div class="list">
                <img src="../assets/images/approve/img1.jpg" alt="">
              </div>
              <div class="list"> 
                <img src="../assets/images/approve/img2.jpg" alt="">
              </div>
              <div class="list"> 
                <img src="../assets/images/approve/img3.jpg" alt="">
              </div>
              <div class="list"> 
                <img src="../assets/images/approve/img4.jpg" alt="">
              </div>
            </div>
        </div>  
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      username: "",
      total: 0,
      loading: true,
      tableData: [],
      tableData2: {},
      expands: [],
      loading: false,
      iconColor: ["#909399"],
      pdfUrl: "/static/Attachment/Help.pdf",
      isadminoras: false,
      isadmin: false,
      defaultActive: "1",
      isntp:false
    };
  },
  methods: {
    Init() {
      this.tableData = [
        { ID: 1, Report: "2.1 Distribution by Key City X Channel X Customer" },
        { ID: 2, Report: "2.2 Distribution by Province X Region" },
        {
          ID: 3,
          Report: "2.4 Distribution by Province X Channel X Belle/YY/RA",
        },
        { ID: 4, Report: "3.1 Distribution by City Tier X Region" },
        { ID: 5, Report: "3.2 Distribution by City Tier" },
        { ID: 6, Report: "3.3 Distribution by HT/MT/LT X Region X Channel" },
        { ID: 7, Report: "4.1 Distribution by Big Store X HT/MT/LT" },
        {
          ID: 8,
          Report: "4.2 Distribution by Location Type X Channel X HT/MT/LT",
        },
        { ID: 9, Report: "5.1 Distribution by FX Type X HT/MT/LT" },
        { ID: 10, Report: "5.2 Distribution by FX Type X KA/RA" },
        { ID: 11, Report: "5.3 Distribution by FX Type (New/Old)" },
        { ID: 12, Report: "6.1. Distribution by Customer" },
        { ID: 13, Report: "6.2. Distribution by Top 7 X Channel" },
        { ID: 14, Report: "7.1. Average GLA/NSS X City Tier" },
      ];

      this.$api
        .get("/Login/GetUserDetail/", {}, (res) => {})
        .then((res) => {
          this.username = res.data;
        });

      this.$api
        .get("/List/GetPendingProjectCount/", { search: "" }, (res) => {})
        .then((res) => {
          if (res.data.status == true) {
            this.total = res.data.content;
          } else {
            this.$message({
              type: "error",
              message: res.data.message,
            });
            return false;
          }
        });
    },
    Report2(row) {
      var url = "";
      if (row == 1) {
        url = "/Report/GetReport_2_1/";
      } else if (row == 2) {
        url = "/Report/GetReport_2_2/";
      } else if (row == 3) {
        url = "/Report/GetReport_2_4/";
      } else if (row == 4) {
        url = "/Report/GetReport_3_1/";
      } else if (row == 5) {
        url = "/Report/GetReport_3_2/";
      } else if (row == 6) {
        url = "/Report/GetReport_3_3/";
      } else if (row == 7) {
        url = "/Report/GetReport_4_1/";
      } else if (row == 8) {
        url = "/Report/GetReport_4_2/";
      } else if (row == 9) {
        url = "/Report/GetReport_5_1/";
      } else if (row == 10) {
        url = "/Report/GetReport_5_2/";
      } else if (row == 11) {
        url = "/Report/GetReport_5_3/";
      } else if (row == 12) {
        url = "/Report/GetReport_6_1/";
      } else if (row == 13) {
        url = "/Report/GetReport_6_2/";
      } else if (row == 14) {
        url = "/Report/GetReport_7_1/";
      }
      return url;
    },
    rowClick(row) {
      //点击行时展开收起
      this.$refs.tableList.toggleRowExpansion(row);
    },
    expandChange(row, expandedRows) {
      let that = this;
      if (expandedRows.length) {
        //此时展开
        that.expands = [];
        if (row) {
          var url = this.Report2(row.ID);
          if (this.isEmpty(url)) {
            this.tableData2 = {};
            that.expands.push(row.ID);
          } else {
            that.loading = true;
            this.$api
              .get(url, {}, (res) => {})
              .then((res) => {
                debugger;
                this.tableData2 = res.data;
                that.loading = false;
                that.expands.push(row.ID);
              })
              .catch((err) => {
                debugger;
                this.$message({
                  type: "error",
                  message: "Bad network, please try again",
                });
                that.loading = false;
              });
          }
        }
      } else {
        //折叠
        that.expands = [];
      }
    },
    getRowKeys(row) {
      //行数据的key，用于优化table的渲染
      return row.ID;
    },
    startapproval() {
      this.$router.push({ path: "/List" });
    },
    endapproval() {
      setTimeout(() => {
        this.$router.push({ path: "/EndList" });
      }, 1000);
    },
    crcategoryclick() {
      setTimeout(() => {
        this.$router.push({ path: "/UnitCostMaintanance" });
      }, 1000);
    },
    help() {
      let routeUrl = this.$router.resolve({ path: "/Help" });
      window.open(routeUrl.href, "_blank");
    },
    logOut() {
      window.localStorage.setItem("SmartAPPToken", "");
      this.$router.push({ path: "/" });
    },
    isEmpty(obj) {
      if (typeof obj == "undefined" || obj == null || obj == "") {
        return true;
      } else {
        return false;
      }
    },
    Playbook() {
      window.open(this.pdfUrl);
    },
    IsAdminOrAs() {
      this.$api
        .get("/Login/IsAdminOrAs/", {}, (res) => {})
        .then((res) => {
          this.isadminoras = res.data;
          if (res.data) {
            this.defaultActive = "1";
          } else {
            this.defaultActive = "3";
          }
        });
    },
    IsAdmin() {
      this.$api
        .get("/Login/IsAdmin/", {}, (res) => {})
        .then((res) => {
          this.isadmin = res.data;
        });
    },
    IsNTP() {
      if(this.isadminoras)
      {
        this.isntp=this.isadminoras
      }else{
          this.$api
        .get("/Login/IsNTP/", {}, (res) => {})
        .then((res) => {
          this.isntp = res.data;
        });
        }      
    },
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
  },
  mounted() {
    this.Init();
    this.IsAdminOrAs();
    this.IsAdmin();
    this.IsNTP();
  },
};
</script>
<style scoped lang="scss">
.left {
  width: 200px;
  /* height: 100%; */
  display: flex;
  flex-direction: column;
  background: #232b33;
  padding-left: 10px;
  box-sizing: border-box;
}
.left .iconList {
  flex: 1;
  display: flex;
  flex-direction: column;
  font-size: 40px;
  line-height: 60px;
  /* align-items: flex-start;
  justify-content: center; */
  padding-bottom: 50px;
  padding-top: 10px;
}
.left .iconList span {
  cursor: pointer;
}
.right {
  width: calc(100% - 200px);
  background: #fcfcfc;
  height: 100%;
  overflow: auto;
}
.top {
  height: 60px;
  background: #232b33;
  color: white;
  text-align: center;
  line-height: 60px;
}
.tag {
  margin-top: 10px;
  border-radius: 2px;
  width: 170px;
  height: 170px;
  border: 1px solid #91969b;
  position: relative;
  background-color: #3e4b54;
}
.arrow {
  position: absolute;
  width: 40px;
  height: 40px;
  bottom: 139px;
  left: 8px;
}
.arrow * {
  display: block;
  border-width: 4px;
  position: absolute;
  border-style: solid dashed dashed dashed;
  font-size: 0;
  line-height: 7;
}
.arrow em {
  border-color: transparent transparent #91969b;
}
.arrow span {
  border-color: transparent transparent #3e4b54;
  top: 1px;
}
.content_title {
  margin: auto;
  margin-top: 20px;
  width: 80%;
  text-align: center;
}
.el-button--text {
  color: #606266;
}
.textBold {
  font-weight: 700;
  color: black;
}
.textNormal {
  font-weight: 400;
}
.textTotal {
  background: rgb(166, 166, 166);
  font-weight: 700;
  color: white;
}
.botton-func {
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 15px;
  width: 130px;
  height: 40px;
  text-align: center;
  background: #a0d800;
  border: 0px #a0d800;
  color: black;
}
.el-menu-list .el-submenu .el-menu-item {
  min-width: auto !important;
  font-size: 13px;
}
.content_title-sub{
  padding: 30px 0 62px 48px;
  font-size: 18px;
  text-align: left;
  color: #000;
  .sub-title{
    font-size: 26px;
    color: #000;
    margin-bottom: 15px;
  }
  .version{
    color: #b7b7b7;
    margin-bottom: 46px;
  }
  .sub-introduce-con{
    margin-bottom: 25px;
    span{
      color: #a0d801;
      font-family: "Lucida Handwriting";
    }
  }
  .sub-img-lists{
    display: flex;
    .list{
      width: calc(50% - 33px);
      margin-right:43px;
      img{
        width: 100%;
      }
    }
  }
}
</style>
<style>
.el-menu-list .el-submenu__icon-arrow,
.el-menu-list .el-icon-arrow-down {
  font-size: 14px !important;
  color: #fff !important;
}
</style>


// WEBPACK FOOTER //
// src/components/ApprovalIndex.vue